<template>
  <v-card
    style="border: 2px solid rgb(76, 175, 80); box-shadow: 5px 5px 2px #c7ced8;"
  >
    <v-flex class="pb-2 pt-0" xs12>
      <div v-if="loading" class="px-3 mt-2 py-2">
        <v-progress-linear
          :indeterminate="true"
          color="success"
        ></v-progress-linear>
      </div>
      <v-form ref="form">
        <v-layout row justify-space-between>
          <v-layout column class="ma-1 px-3">
            <v-card-text
              class="mb-0 pb-0 pt-2 pl-2 mt-3"
              v-if="request && request.id"
            >
              <v-layout row align-center>
                <v-flex xs9>
                  <div class="ml-3 mt-2 body-1 font-weight-light">
                    <v-layout row>
                      <v-flex xs6>
                        <v-layout row align-center>
                          <div
                            class="font-weight-medium mr-3"
                            style="min-width: 80px;"
                          >
                            Technician:
                          </div>
                          <v-autocomplete
                            class="py-0"
                            id="technician"
                            @click="
                              (e) => {
                                !technicianTouchet ? handleTouch(e) : '';
                              }
                            "
                            v-model="editForm.technician"
                            :items="
                              !technicianTouchet
                                ? [request.technicianName]
                                : technicians.map((t) => t.name)
                            "
                            placeholder="Select Technician"
                            dense
                            clearable
                            style="max-width: 200px;"
                            :rules="
                              !closeOpenTicket()
                                ? []
                                : [(value) => !!value || 'Select Technician']
                            "
                          ></v-autocomplete>
                        </v-layout>
                        <v-layout row align-center>
                          <div
                            class="font-weight-medium mr-3"
                            style="min-width: 80px;"
                          >
                            Category:
                          </div>
                          <v-autocomplete
                            @click="
                              (e) => {
                                !categoryTouchet ? handleTouch(e) : '';
                              }
                            "
                            id="category"
                            class="py-0"
                            v-model="editForm.category"
                            :items="
                              !categoryTouchet
                                ? [request.categoryName]
                                : categorys
                            "
                            placeholder="Select Category"
                            dense
                            style="max-width: 200px;"
                            :rules="[rules.required]"
                          ></v-autocomplete>
                        </v-layout>
                        <v-layout row align-center>
                          <div
                            class="font-weight-medium mr-3"
                            style="min-width: 80px;"
                          >
                            Site:
                          </div>
                          <v-autocomplete
                            @click="
                              (e) => {
                                !siteTouchet ? handleTouch(e) : '';
                              }
                            "
                            id="site"
                            class="py-0"
                            v-model="editForm.site"
                            :items="
                              !siteTouchet
                                ? [request.requestSiteName]
                                : sites.map((t) => t.name)
                            "
                            placeholder="Select Site"
                            dense
                            style="max-width: 200px;"
                            :rules="[rules.required]"
                          ></v-autocomplete>
                        </v-layout>
                        <v-layout row align-center>
                          <div
                            class="font-weight-medium mr-3"
                            style="min-width: 80px;"
                          >
                            Priority:
                          </div>
                          <v-autocomplete
                            class="py-0"
                            v-model="editForm.priority"
                            :items="priorityOptions"
                            dense
                            style="max-width: 200px;"
                            :rules="[rules.required]"
                          >
                            <template v-slot:item="{ item }">
                              <v-icon small :color="item.color" class="mr-2"
                                >mdi-box-shadow</v-icon
                              >
                              <span>{{ item.text }}</span>
                            </template>
                            <template v-slot:selection="{ item }">
                              <v-icon small :color="item.color" class="mr-2"
                                >mdi-box-shadow</v-icon
                              >
                              <span>{{ item.text }}</span>
                            </template>
                          </v-autocomplete>
                        </v-layout>
                      </v-flex>
                      <v-flex xs6>
                        <v-layout row align-center>
                          <div
                            class="font-weight-medium mr-4"
                            style="min-width: 80px;"
                          >
                            Status:
                          </div>
                          <v-autocomplete
                            :rules="[rules.required]"
                            class="py-0"
                            v-model="editForm.status"
                            :items="statuses"
                            placeholder="Select Status"
                            dense
                            style="max-width: 200px;"
                          ></v-autocomplete>
                        </v-layout>
                        <v-layout row align-center>
                          <div
                            class="font-weight-medium mr-3"
                            style="min-width: 80px;"
                          >
                            Acknowledge:
                          </div>
                          <v-autocomplete
                            @click="
                              (e) => {
                                !acknowledgeTouchet ? handleTouch(e) : '';
                              }
                            "
                            id="acknowledge"
                            class="py-0"
                            v-model="editForm.acknowledge"
                            :items="
                              !acknowledgeTouchet
                                ? [request.acknowledge]
                                : acknowledgeList
                            "
                            placeholder="Select Acknowledge"
                            dense
                            style="max-width: 200px;"
                            :rules="
                              !closeOpenTicket()
                                ? []
                                : [
                                    (value) =>
                                      !!value ||
                                      'Provide value for field Acknowledge',
                                  ]
                            "
                          ></v-autocomplete>
                        </v-layout>
                        <v-layout row align-center class="mt-3">
                          <div
                            class="font-weight-medium mr-2"
                            style="min-width: 80px;"
                          >
                            Due Date:
                          </div>
                          <input
                            type="date"
                            v-model="editForm.dueDate"
                            :disabled="editForm.dueDateValueNow"
                            style="
                                  padding: 8px;
                                  border: 1px solid #ccc;
                                  border-radius: 4px;
                                  width: 100%;
                                  max-width: 130px;
                                "
                            :style="
                              editForm.dueDateValueNow
                                ? 'background-color: #f5f5f5; cursor: not-allowed;'
                                : ''
                            "
                          />
                          <div class="d-flex flex-column align-center ml-2">
                            <label for="dueDateValueNow" class="caption"
                              >Due Now</label
                            >
                            <v-checkbox
                              v-model="editForm.dueDateValueNow"
                              ref="dueDateValueNow"
                              id="dueDateValueNow"
                              color="primary"
                              hide-details
                              class="mt-0 pt-0"
                            ></v-checkbox>
                          </div>
                        </v-layout>
                        <v-switch
                          color="success"
                          v-model="editForm.markTechnicianAsUnread"
                          id="markTechnicianAsUnread"
                          :class="
                            !request.isRead ? 'mark-unread-switch--blocked' : ''
                          "
                          :label="
                            request.isRead
                              ? 'Mark technician as Unread'
                              : 'Mark technician as Unread (not read yet)'
                          "
                          title="Mark this ticket as unread for the technician"
                          hide-details
                        ></v-switch>
                      </v-flex>
                      <v-flex xs3>
                        <v-layout row align-center>
                          <v-flex
                            style="display: flex; align-items: center; justify-content: center; width: 100%;"
                          >
                            <v-icon
                              v-if="!saving"
                              large
                              left
                              color="green"
                              @click="editTicket"
                              >mdi-check-circle-outline</v-icon
                            >
                            <v-icon
                              v-else
                              class="mdi-spin"
                              large
                              left
                              color="green"
                              >mdi-loading</v-icon
                            >
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </div>
                </v-flex>
              </v-layout>

              <v-layout row align-center>
                <v-flex xs9>
                  <div class="mt-0 ml-3 mb-2 body-1 font-weight-light">
                    <v-layout row align-center>
                      <div
                        class="font-weight-medium mr-3"
                        style="min-width: 80px;"
                      >
                        Subject:
                      </div>
                      <v-text-field
                        class="py-0"
                        v-model="editForm.subject"
                        placeholder="Enter a brief title for your request"
                        dense
                        style="max-width: 65%;"
                        :rules="[rules.required]"
                      ></v-text-field>
                    </v-layout>
                    <v-layout row align-baseline class="mt-4">
                      <div
                        class="font-weight-medium mr-1"
                        style="min-width: 115px; flex-shrink: 0;"
                      >
                        Description:
                      </div>
                      <div
                        v-html="request.description"
                        @input="updateDescription"
                        contenteditable="true"
                        label="Description"
                        rows="5"
                        outline
                        style="flex: 1; min-width: 0; min-height: 160px; padding: 10px; border: 2px solid #ccc; border-radius: 4px;"
                      ></div>
                    </v-layout>
                    <v-layout row align-baseline class="mt-5">
                      <div
                        class="font-weight-medium mr-1"
                        style="min-width: 115px; flex-shrink: 0;"
                      >
                        Resolution:
                      </div>
                      <v-textarea
                        v-model="editForm.resolutionContent"
                        placeholder="Enter the resolution for the ticket"
                        rows="3"
                        outline
                        :rules="
                          !closeOpenTicket()
                            ? []
                            : [
                                (value) =>
                                  !!value ||
                                  'Provide value for field Resolution',
                              ]
                        "
                      ></v-textarea>
                    </v-layout>
                  </div>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-layout>
        </v-layout>
        <v-spacer></v-spacer>
        <div v-if="request && request.id">
          <v-flex
            style="display: flex; align-items: center; justify-content: center; width: 100%;"
          >
            <v-btn small color="default" class="mr-3 mb-2" @click="cancel" dark
              >Back</v-btn
            >
            <v-btn
              small
              color="success"
              class="mr-3 mb-2"
              :loading="saving"
              @click="editTicket"
            >
              Save Changes
            </v-btn>
          </v-flex>
        </div>
      </v-form>
    </v-flex>
  </v-card>
</template>
<script>
import CloseTicketDialog from "./CloseTicketDialog.vue";
import { linkifyPlainUrlsInHtml, priorityOptions } from "./helpDeskHelpers.js";
export default {
  props: {
    initialData: {
      type: Object,
      default: () => ({}),
    },
  },

  components: {
    CloseTicketDialog,
  },
  data: () => ({
    loading: true,
    request: null,
    requester: null,
    SearchUserTickets: false,
    processing: false,
    closeTicketDialog: false,
    addNoteDialog: false,
    addNoteDescription: "",
    saving: false,
    technicians: [],
    categorys: [],
    sites: [],
    acknowledgeList: [],
    statuses: ["Open", "On Hold", "Closed"],
    siteTouchet: false,
    technicianTouchet: false,
    categoryTouchet: false,
    acknowledgeTouchet: false,
    editForm: {
      technician: "",
      category: "",
      priority: "",
      status: "",
      subject: "",
      description: "",
      dueDate: "",
      dueTime: "",
      dueDateValueNow: false,
      site: "",
      acknowledge: "",
      resolutionContent: "",
      markTechnicianAsUnread: false,
    },
    priorityOptions: priorityOptions,
    rules: {
      required: (value) => !!value || "Required.",
    },
  }),

  computed: {},

  watch: {
    initialData(newVal) {
      this.request = newVal.ticket;
    },
    "$route.params.id": {
      immediate: false,
      async handler() {
        this.loading = true;
        await this.load();
      },
    },
  },

  created() {
    this.load();
  },
  methods: {
    searchUserTickets() {
      this.SearchUserTickets = true;
    },
    async load() {
      this.request = this.initialData.ticket;
      this.loading = false;
      this.initializeEditForm();
    },
    initializeEditForm() {
      if (!this.request) return;
      // Initialize technician
      this.editForm.technician = this.request.technicianName
        ? this.request.technicianName
        : "";

      // Initialize category
      this.editForm.category = this.request.categoryName || "";

      // Initialize priority
      this.editForm.priority = this.priorityOptions.find(
        (p) => p.name == this.request.priorityName
      ).text;

      // Initialize status
      this.editForm.status = this.request.statusName || "Open";

      // Initialize subject
      this.editForm.subject = this.request.subject || "";

      // Initialize acknowledge
      this.editForm.acknowledge = this.request.acknowledge || "";

      // Initialize description - strip HTML tags for editing
      //   if (this.request.description) {
      //        const tempDiv = document.createElement("div");
      //       tempDiv.innerHTML = this.request.description;
      //       tempDiv.textContent || tempDiv.innerText || "";
      //   } else {
      //     this.editForm.description = "";
      //   }
      this.editForm.description = this.request.description || "";
      this.editForm.resolutionContent = this.request.resolutionContent || "";
      // Initialize Due Date
      if (this.request.dueByTimeValue) {
        try {
          const dueDate = new Date(Number(this.request.dueByTimeValue));
          const localDateString = new Date(
            dueDate.getTime() - dueDate.getTimezoneOffset() * 60000
          )
            .toISOString()
            .slice(0, 10);

          this.editForm.dueDate = localDateString;

          const hours = String(dueDate.getHours()).padStart(2, "0");
          const minutes = String(dueDate.getMinutes()).padStart(2, "0");
          this.editForm.dueTime = `${hours}:${minutes}`;
        } catch (e) {
          this.editForm.dueDate = "";
          this.editForm.dueTime = "";
        }
      } else {
        this.editForm.dueDate = "";
        this.editForm.dueTime = "";
      }
      // Initialize Mark Technician As Unread
      this.editForm.markTechnicianAsUnread = this.request.isRead ? false : true;

      this.editForm.site = this.request.requestSiteName
        ? this.request.requestSiteName
        : "";
    },
    async getTechnicians() {
      try {
        const response = await this.$http.get("odata/ManageengineTechnicians");
        this.technicians = response.value.map((m) => ({
          name: m.name,
          id: m.id,
        }));
      } catch (error) {
        console.error(error);
      }
    },
    async getCategorys() {
      try {
        const response = await this.$http.get("odata/ManageengineCategories");
        this.categorys = response.value.map((m) => m.name);
      } catch (error) {
        console.error(error);
      }
    },
    async getSites() {
      try {
        const response = await this.$http.get("odata/ManageengineSites");
        this.sites = response.value.map((m) => ({
          name: m.name,
          id: m.id,
        }));
      } catch (error) {
        console.error(error);
      }
    },
    async getAcknowledgeList() {
      try {
        const response = await this.$http.get("odata/ManageengineAcknowledges");
        this.acknowledgeList = response.value.map((m) => m.value);
      } catch (error) {
        console.error(error);
      }
    },
    async editTicket() {
      if (!this.$refs.form.validate(true)) {
        return;
      }
      try {
        this.saving = true;

        const technician = this.technicians.find(
          (t) => t.name === this.editForm.technician
        );
        const technicianId = technician ? technician.id : "clear";

        const site = this.sites.find((t) => t.name === this.editForm.site);
        const siteId = site ? site.id : null;
        var dueDateTimestamp = null;

        const dueDateChanged =
          (this.request.dueByAt &&
            this.request.dueByAt.slice(0, 10) != this.editForm.dueDate) ||
          this.editForm.dueDateValueNow ||
          (!this.request.dueByAt && this.editForm.dueDate);

        if (
          dueDateChanged &&
          this.editForm.dueDate &&
          !this.editForm.dueDateValueNow
        ) {
          const dueDateTime = new Date(`${this.editForm.dueDate}T23:00`);
          dueDateTimestamp = dueDateTime.getTime();
        } else if (dueDateChanged && this.editForm.dueDateValueNow) {
          dueDateTimestamp = new Date().getTime() + 60000;
        }
        if (
          dueDateTimestamp &&
          dueDateTimestamp < this.request.createdTimeValue
        ) {
          return this.$notify({
            group: "notification",
            text:
              "Set valid due by date. Due by date cannot be a prior date to created date.",
            type: "error",
          });
        }

        const subject = this.editForm.subject
          .replace(/  /g, "&nbsp;")
          .replace(/\n/g, "<br>");

        const payload = {};

        if (
          (this.editForm.technician || this.request.technicianName) &&
          this.editForm.technician != this.request.technicianName
        ) {
          payload.TechnicianId = technicianId;
        }
        if (this.editForm.category != this.request.categoryName) {
          payload.CategoryName = this.editForm.category;
        }
        if (
          this.priorityOptions.find((p) => p.text === this.editForm.priority)
            .name != this.request.priorityName
        ) {
          payload.PriorityName = this.priorityOptions.find(
            (p) => p.text === this.editForm.priority
          ).name;
        }
        if (this.editForm.status != this.request.statusName) {
          payload.StatusName = this.editForm.status;
        }
        if (dueDateChanged) {
          payload.DueDateValue = dueDateTimestamp;
        }
        if (subject != this.request.subject) {
          payload.Subject = subject;
        }
        if (this.editForm.description != this.request.description) {
          payload.Description = linkifyPlainUrlsInHtml(
            this.editForm.description
          );
        }
        const prevResolution = this.request.resolutionContent || "";
        if (this.editForm.resolutionContent != prevResolution) {
          payload.Resolution =
            linkifyPlainUrlsInHtml(this.editForm.resolutionContent) || "";
        }
        if (this.editForm.site != this.request.requestSiteName) {
          payload.SiteId = siteId;
        }
        if (
          this.editForm.acknowledge &&
          this.editForm.acknowledge != this.request.acknowledge
        ) {
          payload.Acknowledge = this.editForm.acknowledge;
        }
        if (this.editForm.markTechnicianAsUnread && this.request.isRead) {
          payload.MarkTechnicianAsUnread = true;
        }
        if (Object.keys(payload).length === 0) {
          return this.$notify({
            group: "notification",
            text: "No changes detected",
            type: "info",
          });
        }
        payload.ManageengineID = this.request.manageengineID;
        payload.DisplayID = this.request.displayID;
        await this.$http.put(`api/manageengine/editTicket`, payload);
        await this.$emit("updated");

        this.$notify({
          group: "notification",
          text: `Ticket updated successfully.`,
          type: "success",
        });
      } catch (e) {
        console.error("Error saving ticket:", e);
        this.$notify({
          group: "notification",
          text: "Error updating ticket. Please check console for details.",
          type: "error",
        });
      } finally {
        this.saving = false;
      }
    },
    cancel() {
      this.$emit("cancel");
    },
    updateDescription(v) {
      this.editForm.description = v.target.innerHTML;
    },

    handleTouch(e) {
      if (e.target.id == "site") {
        this.siteTouchet = true;
        this.getSites();
      } else if (e.target.id == "technician") {
        this.technicianTouchet = true;
        this.getTechnicians();
      } else if (e.target.id == "category") {
        this.categoryTouchet = true;
        this.getCategorys();
      } else if (e.target.id == "acknowledge") {
        this.acknowledgeTouchet = true;
        this.getAcknowledgeList();
      }
    },
    closeOpenTicket() {
      return (
        this.editForm.status != this.request.statusName &&
        this.editForm.status == "Closed"
      );
    },
  },
};
</script>
<style>
.mark-unread-switch--blocked {
  pointer-events: none;
  opacity: 0.6;
}
</style>
